import { Organization } from 'src/app/core/models/organization.model';
import { User } from 'src/app/core/models/user.model';
import { DailyTimeEntryModel } from '../timesheet/timesheet.models';

export enum ProjectStatus {
    ACTIVE = 'Actif',
    CLOSED = 'Clôturé',
}

export interface ResearchCategory {
    id: string;
    code: string;
    label: string;
}

export interface PhaseModel {
    id: string;
    code: string;
    label: string;
    researchCategory?: ResearchCategory | null;
    dailyTimeEntries: DailyTimeEntryModel[];
    daysDeclared?: number;
    legacyReportedDays?: number;
    project?: ProjectModel;
}

export interface BusinessActivityModel {
    id: string;
    label: string;
    userReferent: User | null;
    organization?: Organization;
}

export enum SubscriptionBillingTiming {
    START_OF_PERIOD = 'Début de période',
    END_OF_PERIOD = 'Fin de période',
}

export interface BillingMilestoneModel {
    id?: string;
    plannedDate: Date;
    startDate: Date;
    endDate?: Date;
    amountExclTax: number;
    isSent?: boolean;
    isSubscription?: boolean;
    comment?: string | null;
    invoiceNumber?: string | null;
    createdAt?: Date;
    updatedAt?: Date;
    project?: ProjectModel;
    subscriptionBillingTiming?: SubscriptionBillingTiming;
}

export interface SubcontractorInvoiceModel {
    id?: string;
    plannedDate: Date;
    startDate: Date;
    endDate?: Date;
    amountExclTax: number;
    isSent?: boolean;
    isSubscription?: boolean;
    comment?: string | null;
    invoiceNumber?: string | null;
    createdAt?: Date;
    updatedAt?: Date;
    project?: ProjectModel;
    subscriptionBillingTiming?: SubscriptionBillingTiming;
}

export interface ProjectModel {
    id: string;
    code: string; // e.g. "ABC123", "LEAVE", "INTERNAL"
    label: string;
    activity: BusinessActivityModel | null;
    estimatedCloseDate?: Date | null;
    status: ProjectStatus;
    soldAmount: number | null;
    subcontractingAmount?: number | null;
    soldDayRate?: number | null;
    daysRemaining?: number;
    phases?: PhaseModel[];
    leadUser?: User;

    daysSold: number;
    daysDeclared: number;
    legacyReportedDays?: number;

    billingMilestones?: BillingMilestoneModel[];
    subcontractorInvoices?: SubcontractorInvoiceModel[];

    invoicedAmount?: number;
    remainingInvoicedAmount?: number;
}
